
export enum Path {
  Home = '/',
  Home2 = '/home',
  About = '/about',
  News = '/news',
  ContactUs = '/contact',

  Signup = '/auth/register',
  Signin = '/auth',
  ForgotPassword = '/auth/forgot-password',
  ResetPassword = '/auth/reset-password',

  //USER DASHBOARD
  UserDashboard = '/auth/dashboard',
  UserLearn = '/auth/learn',
  UserEarn = '/auth/earn',
  UserSettings = '/auth/settings',
  UserNft = '/auth/nft',
  UserTrade = '/auth/trade',
   UserWallet = '/auth/wallet'
}
